import React from 'react';
import { Outlet, useOutletContext } from 'react-router';
import { useLayoutStore } from '@store';
import { useIsMobile } from '@shared/hooks';
import { cx } from '@shared/utils';
import { Header, Sidebar, MobileNavbar } from './components';
import styles from './BaseLayout.module.css';
import type { OrgLite } from '@shared/types';

/**
 * Extended organization context type that includes both id and name.
 * This maintains compatibility with the org context passed from ProtectedRoute.
 */
interface ProtectedContext {
    org: OrgLite & { id: string };
}

const BaseLayout: React.FC = (): React.ReactElement => {
    const { org } = useOutletContext<ProtectedContext>();
    const isNavbarExpanded = useLayoutStore((s): boolean => s.isNavbarExpanded);
    const isMobile = useIsMobile();

    return (
        <>
            {isMobile ? <MobileNavbar /> : <Sidebar />}
            <div
                className={cx(
                    styles.layout,
                    !isMobile && styles.withNavbar,
                    !isMobile && isNavbarExpanded && styles.withNavbarExpanded,
                )}
            >
                <Header org={org} />
                <div className={styles.body}>
                    <main className={styles.content}>
                        <Outlet />
                    </main>
                </div>
            </div>
        </>
    );
};

export default BaseLayout;
